import React from 'react'
import { Field } from 'redux-form';
import {  Item, painel, fieldset } from 'scorpion-core';

import Anexos from './Anexos';


function componentRelEspelho(comp, dados) {
    return fieldset(comp.label, painel("nao implementadao", { widths: ['*'] }))

}

function component(item) {
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} label={item.label} component={Anexos} />
    </Item>)
}

const modelo = { field: "anexos", label: "Anexos", typeComponente: "AnexosGeral" }

const comp = {
    typeComponente: "AnexosGeral",
    configView: {
        nome: "Anexos Geral",
        modelo

    },
    componentRelEspelho,
    component
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Anexos/AnexosComp.js